<script>
import {
    // ArrowUpIcon,
    // MailIcon,
    // PhoneIcon,
    // YoutubeIcon,
    // MapPinIcon,
    // FacebookIcon,
    // InstagramIcon,
    // TwitterIcon,
    // LinkedinIcon,
    // GithubIcon,
    // GitlabIcon
} from 'vue-feather-icons';

import Navbar from "@/view/front/components/navbar";
import IndexService from "@/MainServices/IndexService.js";
import Footer from "@/view/front/components/footer";
import Swal from "sweetalert2";

/**
 * Page-contact-detail component
 */
export default {
    data() {
        return {
            fname: "",
            lname: "",
            email: "",
            subject: "",
            message: "",
            sendToEmail: "",
        }
    },
    components: {
        Navbar,
        Footer,
    },
    methods: {
        submit() {
            this.sendToEmail = "umer.isetech@gmail.com";
            IndexService.contactMyUni(this.fname, this.lname, this.email, this.subject, this.message, this.sendToEmail).then((res)=> {
                Swal.fire({
                    title: "",
                    text: res.data,
                    icon: "success",
                    confirmButtonClass: "btn btn-secondary",
                    heightAuto: false,
                });
            }).catch((error) => {
                Swal.fire({
                    title: "",
                    text: "Please, provide correct data!",
                    icon: "error",
                    confirmButtonClass: "btn btn-secondary",
                    heightAuto: false,
                });
            });
        }
    }
}
</script>

<template>
<div>
    <Navbar />

    <!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_contact_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="contact-page-top-im-title"> <span style="color: #2eca8b">my</span>Connect</h4>
                <p class="contact-page-top-im-ptext">We’d love to hear from you, <br> <span style="color: #2eca8b">Contact us</span> to help you and answer any question you might have.</p>
                
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero end -->


    <section class="r-contact-page-content-sectionn">
        <div class="container">
            <form action="/action_page.php">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="r-cont-page-form-lbl" for="fname">First Name<span class="text-danger">*</span></label>
                            <input type="text" v-model="fname" class="form-control r-cont-page-form-input" id="fname" placeholder="First Name" name="fname">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label class="r-cont-page-form-lbl" for="lname">Last Name<span class="text-danger">*</span></label>
                            <input type="text" v-model="lname" class="form-control r-cont-page-form-input" id="lname" placeholder="Last Name" name="lname">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="r-cont-page-form-lbl" for="email">Your email address<span class="text-danger">*</span></label>
                    <input type="email" v-model="email" class="form-control r-cont-page-form-input" id="email" placeholder="Your email address" name="email">
                </div>
                <div class="form-group">
                    <label class="r-cont-page-form-lbl" for="subject">Subject Name<span class="text-danger">*</span></label>
                    <input type="text" v-model="subject" class="form-control r-cont-page-form-input" id="subject" placeholder="Subject Name" name="subject">
                </div>
                <div class="form-group">
                    <label class="r-cont-page-form-lbl" for="message">Your message<span class="text-danger">*</span></label>
                    <textarea v-model="message" class="form-control r-cont-page-form-input" row="15" id="message" placeholder="Your message" name="message"></textarea>
                </div>
                <button type="button" @click="submit" class="btn btn-primary">Send message <i class="fas fa-play"></i></button>
            </form>
        </div>
    </section>

    <Footer />
    <!-- Footer End -->

    <!-- <Switcher /> -->
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>

<style>
.modal-content {
    background-color: transparent;
}
</style>
